// import { CompanyType, PersonType, VisitContactType } from '@lendi/core-constants';
//Todo: use core-constans
import { BeneficialOwnerType } from '@lendi/core-constants';

export enum CompanyType {
  Accountant = 'ACCOUNTANT',
  Solicitor = 'SOLICITOR',
  LicensedBuilder = 'LICENSED_BUILDER',
}

export enum CompanyContactType {
  Applicant = 'APPLICANT',
  NonApplicant = 'NON_APPLICANT',
}

export enum PersonType {
  Spouse = 'SPOUSE',
}

export enum VisitContactType {
  LoanParty = 'LOAN_PARTY',
  Tenant = 'TENANT',
  RealEstateAgent = 'REAL_ESTATE_AGENT',
}

export const CONTACT_TYPE_OPTIONS = [
  { label: 'Applicant', value: VisitContactType.LoanParty },
  { label: 'Tenant', value: VisitContactType.Tenant },
  { label: 'Real-estate agent', value: VisitContactType.RealEstateAgent },
];

export const RELATED_PARTY_COMPANY_OWNER_TYPE_LABELS = [
  {
    label: 'Controller',
    value: BeneficialOwnerType.Controller,
  },
  {
    label: 'ShareHolder',
    value: BeneficialOwnerType.ShareHolder,
  },
  {
    label: 'Other',
    value: BeneficialOwnerType.Other,
  },
];

export const RELATED_PARTY_TRUST_OWNER_TYPE_LABELS = [
  {
    label: 'Controller',
    value: BeneficialOwnerType.Controller,
  },
  {
    label: 'ShareHolder',
    value: BeneficialOwnerType.ShareHolder,
  },
];

export {
  CompanyType as COMPANY_TYPE,
  PersonType as PERSON_TYPE,
  VisitContactType as VISIT_CONTACT_TYPE,
  CompanyContactType as COMPANY_CONTACT_TYPE,
};
